<template>
  <section class="page">
    <div class="container py-4">
      <h1 class="mb-3">Climate Community Sustainability</h1>

      <div v-if="loading" class="mb-3">Loading courses…</div>
      <div v-else-if="error" class="alert alert-danger">
        {{ error }}
      </div>

      <div v-else>
        <div class="mb-3">
          <strong>{{ courses.length }}</strong> course(s) found
        </div>

        <div v-if="courses.length === 0" class="alert alert-info">
          No courses found for this category.
        </div>

        <div v-else class="row g-3">
          <div
            v-for="(course, idx) in courses"
            :key="course.id ?? idx"
            class="col-12 col-md-4"
          >
            <div class="card h-100">
              <img
                v-if="course.picture_url"
                class="card-img-top course-img"
                :src="courseImageUrl(course.picture_url)"
                :alt="courseTitle(course)"
                loading="lazy"
              />
              <div v-else class="course-img-placeholder">No image</div>

              <div class="card-body">
                <h5 class="mb-1 card-title">{{ courseTitle(course) }}</h5>
                <div v-if="course.id" class="text-muted small">ID: {{ course.id }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { apiFetch, API_BASE_URL } from '../../api/client'

export default {
  name: 'ClimateCommunitySustainability',
  data() {
    return {
      loading: true,
      error: null,
      courses: [],
      categoryId: 13,
    }
  },
  methods: {
    courseTitle(course) {
      return (
        course.course_name ||
        course.course_title ||
        course.title ||
        course.name ||
        'Course'
      )
    },
    courseImageUrl(pictureUrl) {
      if (!pictureUrl) return ''

      // Already absolute
      if (/^https?:\/\//i.test(pictureUrl) || /^\/\//.test(pictureUrl)) {
        return pictureUrl
      }

      // Ensure relative paths like "upload/..." resolve against the backend origin
      const base = (API_BASE_URL || '').replace(/\/$/, '')
      const path = String(pictureUrl).replace(/^\/+/, '')
      return base ? `${base}/${path}` : `/${path}`
    },
  },
  async mounted() {
    try {
      const res = await apiFetch(`/api/dept-courses?categoryId=${encodeURIComponent(this.categoryId)}`)
      const json = await res.json()
      if (json.status !== 'ok') {
        throw new Error(json.message || 'Failed to load courses')
      }

      this.courses = Array.isArray(json.courses) ? json.courses : []
    } catch (e) {
      this.error = e.message
    } finally {
      this.loading = false
    }
  },
};
</script>

<style scoped>
.course-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.course-img-placeholder {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #666;
}
</style>
